module.exports = __webpack_public_path__ + "img/ic-mic.ad8e6a12.svg";